import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import videojs from 'video.js';
import 'videojs-youtube';

@Component({
  selector: 'app-vjs-player',
  templateUrl: './vjs-player.component.html',
  styleUrls: ['./vjs-player.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VjsPlayerComponent {
  @ViewChild('target', { static: true }) target: ElementRef;

  // Setting the video js options
  // which we need to use
  @Input() options: {
    fluid?: boolean;
    fill?: boolean;
    responsive?: boolean;
    aspectRatio?: string;
    autoplay: boolean;
    sources: {
      src: string;
      type: string;
    }[];
  };
  player: any;
  constructor(private elementRef: ElementRef) {}

  // Initializing a video player on component initialization
  ngOnInit() {
    this.player = videojs(
      this.target.nativeElement,
      this.options,
      function onPlayerReady() {
        // console.log('Video Player on Ready', this);
      },
    );
  }
  // Destroying the player on component destruction
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
